import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-settings-dashboard-header',
  templateUrl: './dashboard-header.component.html',
  styleUrls: ['./dashboard-header.component.scss']
})
export class DashboardHeaderComponent implements OnInit {

  @Input() hasCustomTitle: boolean
  @Input() title: string

  constructor() { }

  ngOnInit(): void {
  }

}
